var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAsPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1551 13.2632L6.12477 10.7805L9.33962 5.05169L13.9124 6.93429L12.1551 13.2632Z",
    fill: "white",
    stroke: "#D41C7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06957 10.7575L12.2173 13.2885C13.2672 13.7208 13.7711 14.93 13.3389 15.9799L12.881 17.092L2.92034 12.9913L3.37819 11.8791C3.81045 10.8292 5.01962 10.3253 6.06957 10.7575Z",
    fill: "white",
    stroke: "#D41C7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02441 1.48071L16.6504 4.62028L16.1811 5.76003C15.7716 6.75472 14.6307 7.23017 13.636 6.82067L9.61582 5.16557C8.62113 4.75606 8.14568 3.61515 8.55519 2.62046L9.02441 1.48071Z",
    fill: "white",
    stroke: "#D41C7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90039 15.0417L4.9798 22.1358",
    stroke: "#D41C7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAsPin);
export default __webpack_public_path__ + "static/media/icon_as_pin.b31a794793beb24a8bd1391f31dbf5e1.svg";
export { ForwardRef as ReactComponent };